import * as React from "react"
import * as Model from "../../../../model"

export default class DebtFormPart
extends React.Component<Props, State> {
	render() {
		const togglers: SectionConfigurationItem[] = [
			{
				label: "Inclure la dette rétrospective",
				name: Names.RetrospectiveEnabled,
			},
			{
				label: "Inclure la dette prospective",
				name: Names.ProspectiveEnabled,
			},
			{
				label: "Inclure les emprunts simulés",
				name: Names.SimulatedLoansEnabled,
			}
		]
		return <section className="section">
			<h2>Structuration de la dette</h2>

			<div className="columns">
				<div className="column is-full is-half-desktop is-one-third-widescreen">
					{togglers.map((toggler, i) => this.renderField(
						toggler.name, toggler.label, i, this.props.disabled))}
				</div>
			</div>

			<div className="columns is-multiline">
				{this.getSectionsConfiguration().map((conf, i) =>
					<section
					className="column is-full is-half-tablet is-one-third-widescreen section"
					key={i}>
						<h3 className="title">{conf.title}</h3>
						{this.renderFields(conf.tables)}
						{this.renderFields(conf.charts)}
					</section>
				)}
			</div>
		</section>
	}

	private getSectionsConfiguration(): SectionConfiguration[] {
		const insertChartsLabel = "Inclure les graphiques"
		const includeChartPerBankLabel = "Inclure un graphique par banque"
		const includeChartPerRateTypeLabel = "Inclure un graphique par type de taux"
		const includeChartPieLabel = "Inclure un graphique par type d'emprunt"

		return [
			{
				charts: {
					label: insertChartsLabel,
					name: Names.Annuities.Charts.Global,
					details: [
						{
							name: Names.Annuities.Charts.PerBank,
							title: includeChartPerBankLabel
						},
						{
							name: Names.Annuities.Charts.PerRateType,
							title: includeChartPerRateTypeLabel
						},
						{
							name: Names.Annuities.Charts.PieChartType,
							title: includeChartPieLabel
						}
					]
				},
				tables: {
					label: "Inclure le tableau des annuités",
					name: Names.Annuities.Tables
				},
				title: "Annuités"
			},
			{
				charts: {
					label: insertChartsLabel,
					name: Names.CapitalReimbursement.Charts.Global,
					details: [
						{
							name: Names.CapitalReimbursement.Charts.PerBank,
							title: includeChartPerBankLabel
						},
						{
							name: Names.CapitalReimbursement.Charts.PerRateType,
							title: includeChartPerRateTypeLabel
						},
						{
							name: Names.Annuities.Charts.PieChartType,
							title: includeChartPieLabel
						}
					]
				},
				tables: {
					label: "Inclure le tableau de remboursement du capital",
					name: Names.CapitalReimbursement.Tables
				},
				title: "Remboursement capital"
			},
			{
				charts: {
					label: insertChartsLabel,
					name: Names.InterestsReimbursement.Charts.Global,
					details: [
						{
							name: Names.InterestsReimbursement.Charts.PerBank,
							title: includeChartPerBankLabel
						},
						{
							name: Names.InterestsReimbursement.Charts.PerRateType,
							title: includeChartPerRateTypeLabel
						},
						{
							name: Names.Annuities.Charts.PieChartType,
							title: includeChartPieLabel
						}
					]
				},
				tables: {
					label: "Inclure le tableau de remboursement des intérêts",
					name: Names.InterestsReimbursement.Tables
				},
				title: "Remboursement intérêts"
			},
			{
				charts: {
					label: insertChartsLabel,
					name: Names.RemainingCapital.Charts.Global,
					details: [
						{
							name: Names.RemainingCapital.Charts.PerBank,
							title: includeChartPerBankLabel
						},
						{
							name: Names.RemainingCapital.Charts.PerRateType,
							title: includeChartPerRateTypeLabel
						},
						{
							name: Names.Annuities.Charts.PieChartType,
							title: includeChartPieLabel
						}
					]
				},
				tables: {
					label: "Inclure le tableau du capital restant dû",
					name: Names.RemainingCapital.Tables
				},
				title: "Capital restant dû"
			},
		]
	}

	private renderField(
		name: string,
		label: string,
		key?: number,
		disabled?: boolean
): React.ReactNode {
		return <div className="field" key={key}>
			<label className="checkbox">
				<input name={name} type="checkbox" checked={this.props.report && this.props.report.includes(name)} disabled={disabled}/>&nbsp;{label}
			</label>
		</div>
	}

	private renderFields(
		confItem: SectionConfigurationItem,
	): React.ReactNodeArray {
		if (!confItem) return null

		const parentField = this.renderField(confItem.name, confItem.label, 0, this.props.disabled)

		if (!(confItem.details && confItem.details.length)) return [parentField]

		return confItem.details.reduce((fields, detail, i) => {
			if (!detail.name) return fields
			return [
				...fields,
				this.renderField(detail.name, detail.title, i + 1, this.props.disabled)
			]
		}, [parentField])
	}
}

export const Names = {
	Annuities: {
		Tables: "debt-annuities-tables",
		Charts: {
			Global: "debt-annuities-charts-global",
			PerBank: "debt-annuities-per-bank-charts-global",
			PerRateType: "debt-annuities-per-rate-type-charts-global",
			PieChartType:"inclure-un-graphique-par-type-d'emprunt"
		}
	},
	CapitalReimbursement: {
		Tables: "debt-capital-reimbursement-tables",
		Charts: {
			Global: "debt-capital-reimbursement-charts-global",
			PerBank: "debt-capital-reimbursement-per-bank-charts-global",
			PerRateType: "debt-capital-reimbursement-per-rate-type-charts-global",
			PieChartType:"inclure-un-graphique-par-type-d'emprunt"
		}
	},
	InterestsReimbursement: {
		Tables: "debt-interests-reimbursement-tables",
		Charts: {
			Global: "debt-interests-reimbursement-charts-global",
			PerBank: "debt-interests-reimbursement-per-bank-charts-global",
			PerRateType: "debt-interests-reimbursement-per-rate-type-charts-global",
			PieChartType:"inclure-un-graphique-par-type-d'emprunt"
		}
	},
	RemainingCapital: {
		Tables: "debt-remaining-capital-tables",
		Charts: {
			Global: "debt-remaining-capital-charts-global",
			PerBank: "debt-remaining-capital-per-bank-charts-global",
			PerRateType: "debt-remaining-capital-per-rate-type-charts-global",
			PieChartType:"inclure-un-graphique-par-type-d'emprunt"
		}
	},
	ProspectiveEnabled: "debt-prospective-enabled",
	RetrospectiveEnabled: "debt-retrospective-enabled",
	SimulatedLoansEnabled: "debt-simulated-loans-enabled"
}

export interface Props {
	decomposedLoans: Model.LoanWithDecomposition[]
	loading?: boolean
	disabled?: boolean
	report?: any
}

interface SectionConfiguration {
	charts?: SectionConfigurationItem
	tables?: SectionConfigurationItem
	title: string
}

interface SectionConfigurationItem {
	label: string
	name: string
	details?: SectionDetailConfiguration[],
}

interface SectionDetailConfiguration {
	name: string
	title: string
}

interface State {}



// WEBPACK FOOTER //
// ./src/component/management-report/form-parts/debt-form-part/index.tsx